module.exports = __webpack_public_path__ + "static/media/splash-screen-mockup.f7c65b5c.png";